export const modules = [
  'admin',
  'billing',
  'order',
  'product',
  'retailer',
  'store',
  'supplier',
] as const;

export type ModuleName = (typeof modules)[number];
